import * as React from "react"

const BackgroundGraySection = ({ children }) => {
	return (
		<div className="mx-auto bg-sectiongreybg p-20 lg:p-20 md:p-20 xxs:p-5">
			{children}
		</div>
	)
}

export default BackgroundGraySection
